import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SubmissionsService } from 'app/services/submissions.service';
import { SessionStorage } from 'app/storage/session.storage';
import { FormService } from 'app/advice-form/form.service';
import { AdvicePdfService } from 'app/advice-form/advice-pdf.service';

const DEFAULT_ACTION: number[] = [2, 7, 11, 17, 23];

const TRL_LABELS: { [statement: string]: string } = {
  A: 'TRL 1-3 (Basic Research)',
  B: 'TRL 4-5 (Applied Research)',
  C: 'TRL 6-7 (Demonstration & Implementation)',
};

@Component({
  selector: 'app-my-applications',
  templateUrl: './my-applications.component.html',
  styleUrls: ['./my-applications.component.scss']
})
export class MyApplicationsComponent implements OnInit {
  loading = true;
  submissions: any[] = [];

  constructor(
    private submissionsService: SubmissionsService,
    public auth: SessionStorage,
    private router: Router,
    private formService: FormService,
    private advicePdfService: AdvicePdfService
  ) {}

  ngOnInit(): void {
    const username = this.auth.getUsername();
    if (!username) {
      this.loading = false;
      return;
    }
    this.submissionsService.getByUsername(username).subscribe({
      next: (submissions) => {
        this.submissions = submissions;
        this.loading = false;
      },
      error: () => { this.loading = false; }
    });
  }

  getId(submission: any): string | null {
    return submission._id?.$oid || null;
  }

  getDate(submission: any): Date | null {
    const oid = this.getId(submission);
    if (!oid) return null;
    return new Date(parseInt(oid.substring(0, 8), 16) * 1000);
  }

  getTrlLabel(submission: any): string {
    return submission.statement ? TRL_LABELS[submission.statement] || submission.statement : '';
  }

  onView(submission: any): void {
    this.router.navigate(['/sot-submission', this.getId(submission)]);
  }

  onExport(submission: any): void {
    this.formService.statement = submission.statement || '';
    this.formService.matrixAnswer = submission.answers || [];
    const sActions = this.formService
      .getSActionsIdByMatrixKeys(submission.answers)
      .filter(action => !DEFAULT_ACTION.includes(action));

    this.advicePdfService.export(
      {
        grants_agreement_number: submission.grants_agreement_number,
        project_acronym: submission.project_acronym,
        full_project_name: submission.full_project_name,
        project_website: submission.project_website,
      },
      this.formService,
      sActions,
      DEFAULT_ACTION
    );
  }
}
